import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditFaqsPage from '@/features/jobs/job-edit-faqs/JobEditFaqsPage';

export const jobEditFaqsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/perguntas-frequentes',
  component: JobEditFaqsPage,
});
